import {_} from "vue-underscore";
import api from "../utils/api.js";

const transactionsUri = api.transactionsUri();

export const transactions = {
    namespaced: true,
    state: {
        transactions: [],
    },
    getters: {
        getTransactions(state) {
            return state.transactions;
        }
    },
    mutations: {
        setTransactions(state, payload) {
            state.transactions = payload.transactions;
        },
    },
    actions: {
        fetchTransactions(context) {
            return api
                .get(transactionsUri)
                .then(response => {
                    context.commit("setTransactions", {
                        transactions: response.transactions
                    });
                })
                .catch(error => {
                    console.log(error);
                });
        },
    }
};
